import { createContext } from "react";

export interface ICoursesCalendarContext {
  coursesCalendarHeight: number;
  coursesCalendarWidth: number;
}

export const coursesCalendarDefaultContext: ICoursesCalendarContext = {
  coursesCalendarHeight: 0,
  coursesCalendarWidth: 0,
};

export const CoursesCalendarContext = createContext<ICoursesCalendarContext>(
  coursesCalendarDefaultContext,
);
